import React, {FC, memo} from 'react';

import {ProjectsTableHeaderNew} from '../../components/ProjectsTableUser';
import {TeamProjectPaginatedList} from './../../components/PaginatedList/PaginatedProjectLists';

type ProjectsSectionProps = {entityName: string; readOnly: boolean};

const ProjectsSectionComp: FC<ProjectsSectionProps> = ({
  entityName,
  readOnly,
}) => {
  return (
    <>
      <ProjectsTableHeaderNew entityName={entityName} readOnly={readOnly} />
      <TeamProjectPaginatedList entityName={entityName} isReadOnly={readOnly} />
    </>
  );
};

export const ProjectsSection = memo(ProjectsSectionComp);
